import React, { useEffect, useState } from "react";
import { Details } from "js/components/Memberships/types";
import { Button, Card, Col, Row, Typography } from "antd";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const { Title, Text } = Typography;

const DetailSection: React.FC = () => {
  const [details, setDetails] = useState<Details>();
  const navigate = useNavigate();

  const { membershipData } = useSelector((state) => state.entities.membership);

  const cardDetails = [
    {
      title: "Membresía Contratado",
      value: details?.plan,
    },
    { title: "Total de Usuarios", value: details?.user_members },
    { title: "Fecha de Renovación", value: details?.renewal_date ?? "N/A" },
    {
      title: "Precio",
      value: (
        <>
          ${details?.price}
          <Text type="secondary">/mes</Text>
        </>
      ),
    },
  ];

  useEffect(() => {
    if (membershipData) {
      setDetails(membershipData);
    }
  }, [membershipData]);

  return (
    <div>
      <Title level={2}>Detalles de la Membresía</Title>
      <Row justify={"start"} gutter={[16, 16]}>
        {cardDetails.map((card, index) => {
          return (
            <Col key={index} xs={24} sm={12} md={12} lg={8} xl={6} xxl={5}>
              <Card
                style={{ textAlign: "center" }}
                bordered={true}
                className="details-card"
                size={"small"}
              >
                <div>
                  <Title level={5}>{card.value}</Title>
                </div>
                <div>
                  <Text>{card.title}</Text>
                </div>
                {card.title == "Membresía Contratado" && (
                  <div style={{ marginTop: 10 }}>
                    <Button
                      ghost
                      type={"primary"}
                      icon={<Icon icon="grommet-icons:upgrade" />}
                      onClick={() => navigate("/memberships/pricing")}
                    >
                      Mejorar
                    </Button>
                  </div>
                )}
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default DetailSection;
